export default __webpack_public_path__ + "static/media/about15.deabaf63.jpeg";